export default __webpack_public_path__ + "img/ecf458cb51ae6c7cc99e662bc93f075d.svg";